<template>
  <div class="wrapper">
    <div>
      <el-card>
        <div class="data_list">
          <ul>
            <li>
              <div>
                {{dataForm.name}}
                <span v-if="dataForm.status == 1">{{$t("crs.task.auditStatus1")}}</span>
                <span v-else-if="dataForm.status == 2">{{$t("crs.task.auditStatus2")}}</span>
                <span v-else-if="dataForm.status == 3">{{$t("crs.task.auditStatus3")}}</span>
                <span v-else-if="dataForm.status == 4">{{$t("crs.task.auditStatus4")}}</span></div>
              <span> {{dataForm.time}}</span>
            </li>
          </ul>
          <ul>
            <li>
              <div>{{dataForm.sum}}</div>
              <span> {{$t("crs.luckyRedPacket.sum")}}</span>
            </li>
            <li>
              <div>{{dataForm.exchangeCount}}</div>
              <span>{{$t("crs.luckyRedPacket.exchangeCount")}}</span>
            </li>
            <li>
              <div>{{dataForm.exchangeRet}}</div>
              <span>{{$t("crs.luckyRedPacket.exchangeRate")}}</span>
            </li>
          </ul>
        </div>
      </el-card>
    </div>

    <FORM v-show="activeName == 'first'" ref="childForm1" @formclick="formclick1" :formData="formData1"></FORM>
    <FORM v-show="activeName == 'second'" ref="childForm2" @formclick="formclick2" :formData="formData2"></FORM>
    <FORM v-show="activeName == 'third'" ref="childForm3" @formclick="formclick3" :formData="formData3"></FORM>

    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin: auto 20px">
      <el-tab-pane :label="$t('crs.task.participateUser')" name="first"></el-tab-pane>
      <el-tab-pane :label="$t('crs.task.granRecord')" name="second"></el-tab-pane>
      <el-tab-pane :label="$t('crs.task.blacklist')" name="third"></el-tab-pane>
    </el-tabs>

    <table-page v-show="activeName == 'first'" ref="childTable1" @btnclick="bthClick1"
                :pageData="pageData1"></table-page>
    <table-page v-show="activeName == 'second'" ref="childTable2" @btnclick="bthClick2"
                :pageData="pageData2"></table-page>
    <table-page v-show="activeName == 'third'" ref="childTable3" @btnclick="bthClick3"
                :pageData="pageData3"></table-page>

    <UPDATE ref="blacklistData" @submit="blacklistClick" :updateData="blacklistData" @uploadFile="uploadFile"></UPDATE>

    <UPDATE ref="auditUpdate" @submit="auditClick" :updateData="auditData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/crs36/util/url"
    import download from '@/utils/download'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    let activationStatusList={"1":window.$t("crs36.luckyRedPacket.activation1"),"2":window.$t("crs36.luckyRedPacket.activation2")}
    let participationStatusList={"1":$t("crs36.luckyRedPacket.participationStatus1"),"2":$t("crs36.luckyRedPacket.participationStatus2"),"3":$t("crs36.luckyRedPacket.participationStatus2"),"3":$t("crs36.luckyRedPacket.participationStatus3"),"4":$t("crs36.luckyRedPacket.participationStatus4"),"5":$t("crs36.luckyRedPacket.participationStatus5"),"6":$t("crs36.luckyRedPacket.participationStatus6")}; //状态类型
    let exchangeStatusList={"1":window.$t("crs36.luckyRedPacket.exchangeStatus1"),"2":window.$t("crs36.luckyRedPacket.exchangeStatus2"),"3":window.$t("crs36.luckyRedPacket.exchangeStatus3"),"4":window.$t("crs36.luckyRedPacket.exchangeStatus4")}
    let check = [];
    let activationStatus2 = {"1":  window.$t("crs.task.activationStatus21"), "2": window.$t("crs.task.activationStatus3")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created() {
            this.loadDetail();
        },
        mounted() {
        },
        methods: {
            handleClick(tab, event) {
                this.activeName = tab.name;
            },
            checkbox(rows) {
                this.check = rows;
                console.log(rows);
            },
            auditClick(row) {
                this.dataChanage(Url.task.updateUser, row, res => {
                    if (res.code == 0) {
                        this.$refs.auditUpdate.close();
                        this.$refs.childTable1.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            /*导入黑名单用户*/
            blacklistClick(row) {
                row.userList = this.user;
                row.taskActivityId = this.$route.query.activityId;
                this.dataChanage(Url.task.importBlacklist, row, res => {
                    if (res.code == 0) {
                        this.$refs.blacklistData.close();
                        this.$message.success("suc");
                    } else {
                        this.$message.error(res.message);
                    }
                })
            },
            uploadFile(col, res) {
                this.user = res.join(",");
            },
            loadDetail() {
                this.$axios.get(Url.luckyRedPacket.infoInit+"/" + this.$route.query.activityId).then(res => {
                    if (res.code == 0) {
                        this.dataForm = {
                            ...this.dataForm,
                            ...res.result
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            },
            /*表格按钮点击事件*/
            bthClick1(clickName, row) {
            },
            /*表格按钮点击事件*/
            bthClick2(clickName, row) {
            },
            /*表格按钮点击事件*/
            bthClick3(clickName, row) {
                if (clickName == "delete") {
                    this.$axios.get(Url.luckyRedPacket.blackDelete + "?id=" + row.id).then(res => {
                        if (res.code == 0) {
                            this.$refs.childTable3.defaultGetData(this.queryData);
                            this.$message.success("suc");
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            },
            /*表格按钮点击事件*/
            bthClick4(clickName, row) {

            },
            downloadTopicComments(data) {
                download.exportExcel(Url.wealthComment.downloadTopicComments, data, "");
            },
            /*查询表单按钮点击事件*/
            formclick1(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable1.defaultQueryData(data);
                } else if (window.$t("crs.task.export") == clickName) {
                    this.downloadUser(data);
                } else if ("修改状态" == clickName) {
                    this.$refs.auditUpdate.open(data);
                }
            },
            formclick2(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable2.defaultQueryData(data);
                } else if (window.$t("crs.task.export") == clickName) {
                    this.downloadReward(data);
                }
            },
            formclick3(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable3.defaultQueryData(data);
                } else if (window.$t("crs.task.blacklistImport") == clickName) {

                    this.$refs.blacklistData.open(data);
                }
            },
            formclick4(clickName, data) {
                if (window.$t("common.search") == clickName || "查询" == clickName) {
                    this.queryData = data;
                    this.$refs.childTable4.defaultQueryData(data);
                }
            },
            downloadUser(data) {
                download.exportExcel(Url.task.exportTaskUserActivityList, data, window.$t("crs.task.userExport"));
            },
            downloadReward(data) {
                download.exportExcel(Url.task.exportTaskUserRewardActivityList, data, window.$t("crs.task.granRecord"));
            },

            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, option || {}, {headers: {'Content-Type': 'application/json'}}).then(res => {
                    this.$refs.childTable1.defaultGetData(this.queryData);
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                activeName: "first",
                dataForm: {
                    name: "",
                    status: 0,
                    time: "",
                    sum: 0,
                    exchangeCount: 0,
                    exchangeRet: "",
                },
                deleteIds: "",
                pageData1: {
                    isShow: false,
                    queryUrl: Url.luckyRedPacket.userList, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "post",
                    cols: [
                        {title: "id", field: 'id', hidden: false},
                        {title:  window.$t("crs36.luckyRedPacket.accountReal"), field: 'account'},
                        {title:  window.$t("crs36.luckyRedPacket.accountName"), field: 'accountName'},
                        {title:  window.$t("crs36.luckyRedPacket.realOpenTime"), field: 'openAccountTime'},
                        {title:  window.$t("crs36.luckyRedPacket.activationStatus"), field: 'activationStatus', render: (data) => {
                                return activationStatusList[data];
                            }
                        },
                        {title:  window.$t("crs36.luckyRedPacket.activationTime"), field: 'activationTime'},
                        {title:  window.$t("crs36.luckyRedPacket.participationTime"), field: 'participateInTime'},
                        {
                            title:  window.$t("crs36.luckyRedPacket.exchangeStatus"), field: 'status', render: (data) => {
                                return exchangeStatusList[data];
                            }
                        },
                    ]
                },
                pageData2: {
                    isShow: false,
                    queryUrl: Url.luckyRedPacket.recordList, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "post",
                    cols: [
                        {title: "id", field: 'id', hidden: false},
                        {title:  window.$t("crs36.luckyRedPacket.accountReal"), field: 'account'},
                        {title:  window.$t("crs36.luckyRedPacket.accountName"), field: 'accountName'},
                        {title:  window.$t("crs36.luckyRedPacket.realOpenTime"), field: 'openAccountTime'},
                        {title:  window.$t("crs36.luckyRedPacket.activationStatus"), field: 'activationStatus', render: (data) => {
                                return activationStatusList[data];
                            }
                        },
                        {title:  window.$t("crs36.luckyRedPacket.activationTime"), field: 'activationTime'},
                        {title:  window.$t("crs36.luckyRedPacket.participationTime"), field: 'participateInTime'},
                        {title:  window.$t("crs36.luckyRedPacket.redBonus"), field: 'bonus'},
                        {title:  window.$t("crs36.luckyRedPacket.receivePrizeTime"), field: 'receivePrizeTime'},
                        {title:  window.$t("crs36.luckyRedPacket.sendStatus"), field: 'status', render: (data) => {
                                return participationStatusList[data];
                            }
                        },
                    ]
                },
                pageData3: {
                    isShow: false,
                    queryUrl: Url.luckyRedPacket.blackList, //请求路径和参数
                    selection: false,
                    sequence: false,
                    method: "post",
                    cols: [
                        {title: "id", field: 'id', hidden: false},
                        {title: window.$t("crs36.luckyRedPacket.accountReal"), field: 'account'},
                        {title: window.$t("crs36.luckyRedPacket.createName"), field: 'createBy'},
                        {title: window.$t("crs36.luckyRedPacket.createTime"), field: 'createDate'},
                        {title: window.$t("crs36.luckyRedPacket.updateDate"), field: 'updateDate'},
                        {
                            title: window.$t("common.handle"), width: '100px', btnClick: [
                                {
                                    name: window.$t("common.delete"), click: "delete", type: "text",auth:"sys:luckyRedPacket:blackDelete"
                                }
                            ]
                        }
                    ]
                },
                queryData: {},
                /*from查询表单*/
                formData1: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'luckyRedPacketId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs36.luckyRedPacket.account"), field: 'account'},
                        {
                            title: window.$t("crs36.luckyRedPacket.openTime"), field: 'openAccountDate', type: 6,
                            isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['openAccountStartTime', 'openAccountEndTime']
                        },
                        {title: window.$t("crs36.luckyRedPacket.activationStatus"), field: 'activationStatus', type: 2, optionList: activationStatusList, isNumber: true},
                        {
                            title: window.$t("crs36.luckyRedPacket.activationTime"), field: 'participationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['activationStartTime', 'activationEndTime']
                        },
                        {title: window.$t("crs36.luckyRedPacket.participationStatus"), field: 'participationStatus', type: 2, optionList: exchangeStatusList, isNumber: true},
                        {
                            title: window.$t("crs36.luckyRedPacket.participationTime"), field: 'participationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['participateInStartTime', 'participateInEndTime']
                        },
                        {click: window.$t("common.search")},
                        {click: window.$t("common.export")},
                    ]
                },
                formData2: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'luckyRedPacketId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs36.luckyRedPacket.account"), field: 'account'},
                        {
                            title: window.$t("crs36.luckyRedPacket.openTime"), field: 'openAccountDate', type: 6,
                            isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['openAccountStartTime', 'openAccountEndTime']
                        },
                        {title: window.$t("crs36.luckyRedPacket.activationStatus"), field: 'activationStatus', type: 2, optionList: activationStatusList, isNumber: true},
                        {
                            title: window.$t("crs36.luckyRedPacket.activationTime"), field: 'participationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['activationStartTime', 'activationEndTime']
                        },
                        {title: window.$t("crs36.luckyRedPacket.sendStatus"), field: 'participationStatus', type: 2, optionList: participationStatusList, isNumber: true},
                        {
                            title: window.$t("crs36.luckyRedPacket.participationTime"), field: 'participationTime', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['participateInStartTime', 'participateInEndTime']
                        },
                        {click: window.$t("common.search")},
                        {click: window.$t("common.export")},
                    ]
                },
                formData3: {
                    hasLable: true,
                    cols: [
                        {title: '主键', field: 'luckyRedPacketId', hidden: true, data: this.$route.query.activityId},
                        {title: window.$t("crs36.luckyRedPacket.accountReal"), field: 'account'},
                        {
                            title: window.$t("crs.task.createDate"), field: 'time', type: 6, isArray: true,
                            format: 'yyyy-MM-dd HH:mm:ss',
                            startEndParam: ['startDate', 'endDate']
                        },
                        {click: window.$t("common.search")},
                        {click: window.$t("crs.task.blacklistImport")},
                    ]
                },
            }
        }
    }
</script>
<style lang="scss" scoped>
  .data_list {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;

      li {
        text-align: center;

        div {
          font-size: 26px;
          color: #333;
        }

        span {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }

  ul,
  li {
    list-style: none;
  }
</style>
